import {
  makeStyles, Grid, ListItemText, Divider, ListItem, List, Button,
} from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Page from 'src/components/Page'
import classnames from 'classnames'
import withWidth, { isWidthUp, isWidthDown } from '@material-ui/core/withWidth'
// eslint-disable-next-line import/no-cycle
import RolesStep from './RolesStep'
import { getEvents, selectorEvents, getEventsId } from '../../app/slices/eventSlice'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '1rem 0',
    '& .MuiAlert-message': {
      padding: '5 0 !important',
      width: '100%',
    },
    '& .MuiAlert-icon': {
      marginRight: '0 !important',
    },
    '& .MuiList-padding': {
      paddingBottom: '0 !important',
    },
  },
  title: {
    marginBottom: 15,
  },
  list: {
    width: '100%',
    padding: '0 1rem',
    boxShadow: '0 0 1px 0 rgba(26, 24, 24, 0.2)',
    backgroundColor: '#fff',
    marginBottom: theme.spacing(3.7),
  },
  listItem: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(6,1fr)',
    gridColumnGap: theme.spacing(2),
    margin: '1rem 0',
  },
  listItemTitle: {
    textAlign: 'center',
  },
  textAlignRight: {
    textAlign: 'left',
  },
  listItemData: {
    maxWidth: '25%',
    textAlign: 'center',
    marginLeft: '-6px',
  },
  listItemPrimary: {
    fontSize: theme.spacing(2),
    fontWeight: 'normal',
    color: '#585858',
    width: '100%',
  },
  ListItemRespansive: {
    borderBottom: '0.5px solid #e7e7e7',
  },
  listItemDataRespansive: {
    textAlign: 'right',
  },
  btn: {
    color: 'white',
    minWidth: '50%',
    margin: '0 auto',
    borderRadius: theme.spacing(0.9),
    backgroundColor: '#405df0',
    '&:hover': {
      backgroundColor: '#10279b',
    },
    '& .MuiButton-label': {
    },
  },
  btnRespansive: {
    color: 'white',
    backgroundColor: '#405df0',
    '&:hover': {
      backgroundColor: '#10279b',
    },
  },
}))

const columnLists = {
  title: 'عنوان',
  subject: 'موضوع',
  closingDate: 'تاریخ بستن رویداد',
  expierDate: 'تاریخ انقضای رویداد',
  category: 'رده سنی رویداد',
  events: 'رویداد',
}
//
const TablesStep = ({ width, setActiveStep, steps }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const eventUser = useSelector((state) => selectorEvents(state))
  const handleClick = (id) => {
    dispatch(getEventsId(id))
    setActiveStep(steps[RolesStep.name])
  }
  useEffect(() => {
    dispatch(getEvents())
  }, [])
  return (
    <Page
      className={classes.root}
      title="شرکت در رویداد"
    >
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>
          {
           isWidthUp('md', width) && (
           <List component="nav" classes={{ root: classes.list }}>
             <ListItem classes={{ root: classes.listItem }}>
               {
                    Object.keys(columnLists).map((col, j) => (
                      <ListItemText
                        key={j}
                        classes={j === 0 ? {
                          root: classnames(classes.listItemTitle, classes.textAlignRight),
                        } : { root: classes.listItemTitle }}
                        primary={columnLists[col]}
                      />
                    ))
                  }
             </ListItem>
             <Divider />
               {
                    eventUser.map((item, j) => {
                      const lastIndex = eventUser.length - 1
                      return (
                        <>
                          <ListItem classes={{ root: classes.listItem }}>
                            {
                              Object.keys(columnLists).map((col, index) => {
                                const classNmame = () => {
                                  if (index === 0) {
                                    return classnames(classes.listItemTitle, classes.textAlignRight)
                                  }
                                  return classes.listItemTitle
                                }
                                if (col === 'events') {
                                  return (
                                    <Button
                                      onClick={() => handleClick(item.id)}
                                      key={j}
                                      classes={{
                                        root: classes.btn,
                                      }}
                                    >
                                      {columnLists[col]}
                                    </Button>
                                  )
                                }
                                return (
                                  <ListItemText
                                    key={index}
                                    classes={{
                                      root: classNmame(),
                                    }}
                                    primary={(col === 'category') ? item[col].name : item[col]}
                                  />
                                )
                              })
                            }

                          </ListItem>
                          {lastIndex !== j && <Divider /> }
                        </>
                      )
                    })
                  }
           </List>
           )
         }
          {
           isWidthDown('sm', width) && eventUser.map((item) => {
             return (
               <List component="nav" classes={{ root: classes.list }}>
                 {
                     Object.keys(columnLists).map((col, j) => {
                       return (
                         <ListItem key={j} classes={{ root: classes.ListItemRespansive }}>
                           <ListItemText
                             classes={{
                               primary: classnames(classes.listItemTitle, classes.textAlignRight),
                             }}
                             primary={columnLists[col]}
                           />
                           {
                            col === 'events'
                              ? (
                                <Button
                                  onClick={() => handleClick(item.id)}
                                  key={j}
                                  classes={{
                                    root: classes.btnRespansive,
                                  }}
                                >
                                  {columnLists[col]}
                                </Button>
                              )
                              : (
                                <ListItemText
                                  classes={{
                                    root: classes.listItemDataRespansive,
                                    primary: classes.listItemPrimary,
                                  }}
                                  primary={(col === 'category') ? item[col].name : item[col]}
                                />
                              )
                          }

                         </ListItem>
                       )
                     })
                       }
               </List>
             )
           })
         }

        </Grid>
      </Grid>
    </Page>
  )
}
export default withWidth()(TablesStep)
